import api, { assetAdditionalData } from '../api';
import { getMockAsset } from './asset/mock';

const getAssetEndpoint = (id) => `/assets/${id}?additional=${assetAdditionalData}`;

const getById = async ({ vendor, assetId }) => api(
    vendor,
    getAssetEndpoint(assetId)
);

export default {
    getById,
    getMockAsset
};
